import { SubscriptionPlan } from '@affine/graphql';

export const subscriptionPlanLabels: Record<SubscriptionPlan, string> = {
  [SubscriptionPlan.AI]: 'AI',
  [SubscriptionPlan.Enterprise]: '企业版',
  [SubscriptionPlan.Free]: '免费版',
  [SubscriptionPlan.Pro]: 'Pro',
  [SubscriptionPlan.SelfHosted]: '自托管版',
  [SubscriptionPlan.SelfHostedTeam]: '自托管团队版',
  [SubscriptionPlan.Team]: '团队版',
};
